export default function options(field,option) {

	var optionData = {
		planType: {
			"developmentPlan": "Bebauungsplan",
			"landUsePlan": "Flächennutzungsplan",
			"spatialPlanning": "Raumordnungplan",
			"landscapePlan": "Landschaftsplan",
			"otherPlan": "Sonstiges Planwerk",
		},
		depthOfCoverage: {
			"fullVector": "vollvektoriell",
			"rasterEncircling": "Raster-Umring",
		},
		procedure: {
			"1000": "(1000) Normales BPlan Verfahren",
			"2000": "(2000) BPlan Verfahren nach § 13 BauGB",
			"3000": "(3000) BPlan Verfahren nach § 13a BauGB",
			"4000": "(4000) BPlan Verfahren nach § 13b BauGB",
		},
		orderTypes: {
			'createNewXPlanFormGivenData':'Neues Planwerk',
			'createNewXPlanFromExistingPlan':'Überführung ',
			'modifyGivenXPLln': 'Änderung/Eweiterung '
		},
		legalPlanStatus: {
			"1000": "(1000) Ein Aufstellungsbeschluss der Gemeinde liegt vor",
			"2000": "(2000) Ein Planentwurf liegt vor",
			"2100": "(2100) Die frühzeitige Beteiligung der Behörden (§ 4 Abs. 1 BauGB) hat stattgefunden",
			"2200": "(2200) Die frühzeitige Beteiligung der Öffentlichkeit hat stattgefunden",
			"2300": "(2300) Die Beteiligung der Behörden hat stattgefunden (§ 4 Abs. 2 BauGB)",
			"2400": "(2400) Der Plan hat öffentlich ausgelegen (§ 3 Abs. 2 BauGB)",
			"3000": "(3000) Die Satzung wurde durch Beschluss der Gemeinde verabschiedet",
			"4000": "(4000) Der Plan ist in kraft getreten",
		},
		bidProcess: {
			"xplanung24": "Vergabe über XPLANUNG24",
		},
		requestedXPlanVersion: {
			"5.1": "5.1",
			"5.2": "5.2",
			"5.3": "5.3",
			"5.4": "5.4",
			"6.x": "6.x",
		},
		otherRequirements: {
			"1000": "Bemaßungen als Objekte erfassen",
			"2000": "Bestandsdarstellungen erfassen",
			"3000": "Änderungs-GML abhängiger Planwerke",
			"4000": "Übersetzungskonzept für nicht-standardisierte Planzeichen",
			"5000": "Bereinigung der Ausgangsdaten",
		},
		textualDeterminations: {
            "asTextSectionsOnObjects": "als Textabschnitte an Objekten",
            "asExternalReferenceToScope": "als externe Referenz an Geltungsbereich",
        }
	}


	if(optionData?.[field]?.[option]) {
		return optionData?.[field]?.[option];
	} else {
		return null;
	}



}
